export default "__VITE_ASSET__tfjb1MZf__"